import HelpUtils from '@/utils/HelpUtils';
import {
  AppInfoTypes,
  ShareParamTypes,
  miniProgramTypes,
  OpenAppInfoTypes,
} from '@/utils/InterfaceTypesUtils';

class MainUtils {
  /**
   * 判断是否是Android
   * @returns boolen
   */
  static isAndroid = (): boolean => /android/gi.test(navigator.appVersion);

  /**
   * 是否在app内，带上ver，则是否是在指定版本号的app内，范围版本
   * @param {*} ver
   * @returns
   */
  static isInApp = (ver = ''): boolean => {
    let res = false;
    if ((window as any).RNMMB === true) {
      res = true;
      if (ver !== undefined && ver !== '') {
        const appInfo: AppInfoTypes = MainUtils.appInfo();
        if ((appInfo?.c_appver ?? '') !== '') {
          if (
            Number((appInfo?.c_appver ?? '').replace(/\./g, '')) < Number(ver.replace(/\./g, ''))
          ) {
            res = false;
          }
        }
      }
    }
    return res;
  };

  /**
   * 是否是传入的app版本
   * @param {*} ver
   * @returns
   */
  static isAppVer = (ver = ''): boolean => {
    let res = false;
    if (ver !== '' && (window as any).RNMMB === true) {
      const appInfo: AppInfoTypes = MainUtils.appInfo();
      if (
        (appInfo?.c_appver ?? '') !== '' &&
        Number((appInfo?.c_appver ?? '').replace(/\./g, '')) === Number(ver.replace(/\./g, ''))
      ) {
        res = true;
      }
    }
    return res;
  };

  /**
   * app下载跳转
   */
  static appDownload = (): void => {
    window.location.href = 'https://app.manmanbuy.com/appDownload2.html';
  };

  /**
   * 是否登录
   * @returns boolean
   */
  static isLogin = (): boolean => {
    const appInfo: AppInfoTypes = MainUtils.appInfo();
    return (appInfo?.u_name ?? '') !== '';
  };

  /**
   * app内基础信息
   * @returns any
   */
  static appInfo = (): AppInfoTypes => {
    return (window as any).RNMMB === true ? (window as any).api.getMMBAPPInfo() : null;
  };

  /**
   * 获取慢慢买APP的UA
   */
  static mmbUseragent = (): string => navigator.userAgent;

  /**
   * 获取纯净的用户UA
   */
  static pureUseragent = (): string => {
    const mmbUseragent = MainUtils.mmbUseragent();
    return mmbUseragent
      .replace(' - mmbWebBrowse - iOS iPhone', '')
      .replace(' - mmbWebBrowse - android ', '')
      .replace(' - mmbWebBrowse - ios ', '');
  };

  /**
   * APP内跨域AJAX的post（慢慢买UA）
   */
  static ajaxPost = (
    url: string,
    dataType: string,
    params: {[key: string]: unknown},
    headerParams: string,
    timeout?: number,
  ): Promise<any> => {
    const ajaxParams = MainUtils.dealUrlParam(params);

    return new Promise(resolve => {
      (window as any).api.ajax(
        {
          url,
          type: 'post',
          dataType,
          data: ajaxParams,
          timeout: timeout || 15000,
          appAjax: true,
          header: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'User-Agent': MainUtils.mmbUseragent(),
            app_key: headerParams,
          },
        },
        (ret: any) => {
          resolve(ret);
        },
      );
    });
  };

  /**
   * APP内跨域AJAX的get（慢慢买UA）
   */
  static ajaxGet = (
    url: string,
    dataType: string,
    params: {[key: string]: unknown},
  ): Promise<any> => {
    const ajaxParams = MainUtils.dealUrlParam(params);
    return new Promise(resolve => {
      (window as any).api.ajax(
        {
          url,
          type: 'get',
          dataType,
          data: ajaxParams,
          timeout: 15000,
          appAjax: true,
          header: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'User-Agent': MainUtils.mmbUseragent(),
          },
        },
        (ret: any) => {
          resolve(ret);
        },
      );
    });
  };

  /**
   * APP内跨域AJAX的post（不带慢慢买UA）
   */
  static thirdAjaxPost = (
    url: string,
    dataType: string,
    params: {[key: string]: unknown},
    charset: string,
  ): Promise<any> =>
    new Promise(resolve => {
      (window as any).api.ajax(
        {
          url,
          type: 'post',
          dataType,
          data: params,
          timeout: 15000,
          charset: charset || 'utf-8',
          header: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'User-Agent': MainUtils.pureUseragent(),
          },
        },
        (ret: any) => {
          resolve(ret);
        },
      );
    });

  /**
   * APP内跨域AJAX的get（不带慢慢买UA）
   */
  static thirdAjaxGet = (
    url: string,
    dataType: string,
    params: {[key: string]: unknown},
    charset: string,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    header?: any,
  ): Promise<any> =>
    new Promise(resolve => {
      (window as any).api.ajax(
        {
          url,
          type: 'get',
          dataType,
          data: params,
          timeout: 15000,
          charset: charset || 'utf-8',
          header: header ?? {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'User-Agent': MainUtils.pureUseragent(),
          },
        },
        (ret: any) => {
          resolve(ret);
        },
      );
    });

  static urlParam = (param: {[key: string]: any}): string => {
    let res = '';
    res += Object.keys(param ?? {}).map(key => {
      const value = param[key];
      return `&${encodeURIComponent(key)}=${encodeURIComponent(
        MainUtils.isObject(value) ? JSON.stringify(value) : value,
      )}`;
    });
    return res;
  };

  /**
   * 判断是否是对象
   * @param obj
   */
  static isObject = (obj: unknown): boolean =>
    typeof obj === 'object' &&
    (Object.prototype.toString.call(obj).toLowerCase() === '[object array]' ||
      Object.prototype.toString.call(obj).toLowerCase() === '[object object]');

  /**
   * 判断对象是否是空
   */
  static isEmptyObject = (e: {[key: string]: unknown}): boolean => {
    let t;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax,no-unreachable-loop
    for (t in e) return !1;
    return !0;
  };

  /**
   * 处理请求参数
   */
  static dealUrlParam = (param: {[key: string]: unknown}): {[key: string]: unknown} => {
    let params = param;
    if (typeof params !== 'object') {
      params = {};
    }
    if ((window as any).RNMMB === true) {
      const appInfo: AppInfoTypes = MainUtils.appInfo();
      if ((appInfo?.c_appver ?? '') !== '') {
        /* 设备相关信息 */
        params.t = Date.now().toString(); // 时间戳
        params.jsoncallback = '?';
        params.username = appInfo.u_name; // 用户名
        params.sign = appInfo.sign; // 用户签名
        params.c_appver = appInfo.c_appver; // 应用版本号
        params.c_ostype = appInfo.c_ostype; // 系统类型 eg：ios，android
        params.c_osver = appInfo.c_osver; // 手机平台的系统版本
        params.c_devid = appInfo.c_devid; // 设备唯一标识
        params.c_devmodel = appInfo.c_devmodel; // 设备型号  eg：iphone 5s
        params.c_operator = appInfo.c_operator; // 运营商名称，若未获取到则返回none
        params.c_win = appInfo.c_win; // 设备大小
        params.c_dp = appInfo.c_dp; // 设备dp值
        params.c_firstchannel = appInfo.c_firstchannel;
        params.c_firstquerendate = appInfo.c_firstquerendate;
        params.c_channel = appInfo.c_channel;
        /* /设备相关信息 */
      }
    }
    return params;
  };

  static getPureJsonHtml = (str = ''): string => {
    const firstIndex = str.indexOf('{');
    const lastIndex = str.lastIndexOf('}');
    return str.substring(firstIndex, lastIndex + 1);
  };

  /**
   * 获取安全区域
   */
  static safeArea = (): any => {
    let res = {
      top: 0,
      bottom: 0,
    };
    const appInfo: AppInfoTypes = MainUtils.appInfo();
    if ((appInfo?.c_safearea ?? '') !== '') {
      const area = (appInfo?.c_safearea ?? '').split('_');
      res = {
        top: Number(area?.[0] ?? '0'),
        bottom: Number(area?.[1] ?? '0'),
      };
    }
    return res;
  };

  static uzStorage = (): any => window.localStorage;

  /**
   * 设置localStorage
   */
  static setStorage = (key: string, value: string): void => {
    let v = value;
    if (typeof v === 'object') {
      v = JSON.stringify(v);
      v = `obj-${v}`;
    } else {
      v = `str-${v}`;
    }
    const ls = MainUtils.uzStorage();
    if (ls) {
      ls.setItem(key, v);
    }
  };

  /**
   * 读取localStorage
   */
  static getStorage = (key: string): any => {
    const ls = MainUtils.uzStorage();
    let res = '';
    if (ls) {
      let v = ls.getItem(key);
      if (!v) {
        res = '';
      } else {
        if (v.indexOf('obj-') === 0) {
          v = v.slice(4);
          // eslint-disable-next-line consistent-return
          res = JSON.parse(v);
        }
        if (v.indexOf('str-') === 0) {
          // eslint-disable-next-line consistent-return
          res = v.slice(4);
        }
      }
    }
    return res;
  };

  // 删除localStorage
  static rmStorage = (key: string): void => {
    const ls = MainUtils.uzStorage();
    if (ls && key) {
      ls.removeItem(key);
    }
  };

  /**
   * 清空localStorage
   */
  static clearStorage = (): void => {
    const ls = MainUtils.uzStorage();
    if (ls) {
      ls.clear();
    }
  };

  /**
   * 设置Cookie
   */
  static setCookie = (cookieName: string, cookieValue: string, cookieDates: number): void => {
    const d = new Date();
    d.setDate(d.getDate() + cookieDates);
    document.cookie = `${cookieName}=${cookieValue};expires=${d.toUTCString()}`;
  };

  /**
   * 读取Cookie
   */
  static getCookie = (cookieName: string): string => {
    const cookieStr = unescape(document.cookie);
    const arr = cookieStr.split('; ');
    let cookieValue = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr.length; i++) {
      const temp = arr[i].split('=');
      if (temp[0] === cookieName) {
        cookieValue = temp?.[1] ?? '';
        break;
      }
    }
    return cookieValue;
  };

  /**
   * 删除Cookie
   */
  static rmCookie = (cookieName: string): void => {
    document.cookie = `${encodeURIComponent(cookieName)}=; expires=${new Date()}`;
  };

  /**
   * 统计埋点logsearch
   */
  static statisticsData = (type: string, value: string): void => {
    (window as any).MMBJsBridge.commonAction(
      'func',
      `MainUtils.statisticsData('${type}', ${JSON.stringify(value)});`,
    );
  };

  static doGoWeb = (url: string, params: {[key: string]: unknown}): void => {
    const res = HelpUtils.getPath(url);
    if (MainUtils.isInApp()) {
      (window as any).MMBJsBridge.goLink(res, params ?? {});
    } else {
      window.location.href = res;
    }
  };

  /**
   * 关闭网页
   */
  static closeWin = (): void => {
    if (MainUtils.isInApp()) {
      (window as any).MMBJsBridge.closeWin();
    } else {
      window.history.go(-1);
    }
  };

  /**
   * 淘宝百川
   * @param url
   */
  static doAlimama = (url: string): void => {
    const dpLink = ['tbopen://', 'taobao://', 'tmall://page.tm'];
    if (MainUtils.isInApp()) {
      if (dpLink.some(prefix => url.startsWith(prefix))) {
        MainUtils.openApp({urlScheme: url, url});
      } else {
        (window as any).MMBJsBridge.doAlimama(url);
      }
    } else {
      window.location.href = url;
    }
  };

  /**
   * 京东开普勒
   * @param url
   */
  static doKepler = (url: string): void => {
    if (MainUtils.isInApp()) {
      (window as any).MMBJsBridge.doKepler(url);
    } else {
      window.location.href = url;
    }
  };

  /**
   * 唤起口令弹窗
   * @param url
   */
  static doCopyWord = (params: any): void => {
    if (MainUtils.isInApp('4.7.52')) {
      (window as any).MMBJsBridge.copyWord(params);
    }
  };

  static openApp = (params: OpenAppInfoTypes): void => {
    const appInfo: AppInfoTypes = MainUtils.appInfo();
    if (
      MainUtils.isInApp('4.2.80') ||
      ((appInfo?.c_app ?? '') === 'ddd' &&
        Number((appInfo?.c_appver ?? '').replace(/\./g, '')) > 159) ||
      (appInfo?.c_app ?? '') === 'lsjgcx'
    ) {
      (window as any).MMBJsBridge.openApp(params?.urlScheme ?? '');
    } else {
      MainUtils.doGoWeb(params?.url ?? '', {});
    }
  };

  /**
   * 微信小程序
   * @param url
   */
  static launchMiniProgram = (params: miniProgramTypes): void => {
    if (MainUtils.isInApp()) {
      (window as any).MMBJsBridge.launchMiniProgram({
        userName: params.userName, // 小程序原始id
        miniprogramType: params.miniprogramType, // 小程序的类型 正式版:0，测试版:1，体验版:2
        path: params.path, // 拉起小程序页面的可带参路径
      });
    }
  };

  /**
   * 显示加载中
   */
  static showProgress = (): void => {
    (window as any).MMBJsBridge.showProgress();
  };

  /**
   * 隐藏加载中
   */
  static hideProgress = (): void => {
    (window as any).MMBJsBridge.hideProgress();
  };

  /**
   * 打开精选折扣详情页
   * @param id
   */
  static goCuDetail = (id: string | number): void => {
    (window as any).MMBJsBridge.goCuDetail(id);
  };

  /**
   * 打开全网折扣详情页
   * @param id
   */
  static goFriendDetail = (id: string | number): void => {
    (window as any).MMBJsBridge.goFriendDetail(id);
  };

  /**
   * 设置标题
   * @param title
   */
  static setTitle = (title: string): void => {
    (window as any).MMBJsBridge.setTitle(title);
  };

  /**
   * 分享
   * @param params
   */
  static openShare = (params: ShareParamTypes): void => {
    (window as any).MMBJsBridge.openShare(params);
  };

  /**
   * APP初始化完成
   * @param func
   */
  static apiready = (func: unknown): void => {
    const Window = window as any;
    if (Window.apiready) {
      Window.apiready = HelpUtils.mergeFunction(Window.apiready, func);
    } else {
      Window.apiready = func;
    }
  };

  /**
   * 获取浏览地址参数
   * @param sURL
   * @param key
   */
  static getQueryString = (sURL: string, key: string): string => {
    let newUrl = sURL;
    if (!sURL) newUrl = window.location.href;
    const newKey = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = `[\\?&]${newKey}=([^&#]*)`;
    const regex = new RegExp(regexS);
    const results = regex.exec(newUrl);
    return results == null ? '' : results[1];
  };

  /**
   * 获取浏览地址所有参数返回一个对象
   * @param paramString
   */
  static getLocationSearch = (paramString: string): object => {
    if (!paramString || paramString.length === 0) {
      return {};
    }
    // eslint-disable-next-line no-param-reassign
    paramString = paramString.slice(paramString.indexOf('?') + 1);
    let paramList = [];
    const paramObj: any = {};
    if (paramString.indexOf('&') >= 0) {
      paramList = paramString.split('&');
    } else {
      paramList[0] = paramString;
    }
    paramList.forEach(value => {
      paramObj[value.split('=')[0]] = decodeURIComponent(value.split('=')[1]);
    });
    return paramObj;
  };

  /**
   * 获取底部安全区域
   * @returns {number}
   */
  static getBottomSpace = (): number => MainUtils.safeArea().bottom;

  /**
   * 获取状态栏高度
   * @returns {unknown}
   */
  static getStatusBarHeight = (): number => MainUtils.safeArea().top;

  /**
   * 清除首尾空格
   * @param str
   */
  static trim = (str: string): string => HelpUtils.trim(str ?? '');

  /**
   * 统一统计（umeng、td、logsearch）
   * 3.3.90
   * @param trackParams
   * {
   *     um: "", //友盟
   *     td:{   //TD
   *         page:"",
   *         event:"",
   *     },
   *     log:"", //AppLog
   *     trackData: { //统计数据
   *
   *     },
   *     spm: {
   *       pName: "",
   *       eName: "",
   *       aName: "",
   *     }
   * }
   */
  static logTrack = (trackParams: {[key: string]: unknown}): void => {
    (window as any).MMBJsBridge.commonAction(
      'func',
      `MainUtils.logTrack(${JSON.stringify(trackParams)})`,
    );
  };

  /**
   * 统一统计（火山、logsearch）
   * 3.6.80
   * @param trackParams
   * {
   *     hs: "", //友盟
   *     log:"", //AppLog
   *     trackData: { //统计数据
   *
   *     },
   *     spm: {
   *       pName: "",
   *       eName: "",
   *       aName: "",
   *     }
   * }
   */
  static logTrackV2 = (trackParams: {[key: string]: unknown}): void => {
    (window as any).MMBJsBridge.commonAction(
      'func',
      `MainUtils.logTrackV2(${JSON.stringify(trackParams)})`,
    );
  };

  /**
   * 公用外部方法
   * @param type
   * @param value
   */
  static commonAction = (type: string, value: string): void => {
    (window as any).MMBJsBridge.commonAction(type, value);
  };

  /**
   * 去除html标签
   * @param str
   */
  static delHtmlTag = (str: string): string =>
    (str ?? '')
      .replace(/<[^<>]+?>/g, '')
      .replace(/['"\\/\b\f\n\r\t]/g, '')
      .replace(/&nbsp;/gi, '')
      .replace(/<br>/g, '')
      .replace(/<br \/>/g, '')
      .replace(/<br\/>/g, '')
      .replace(/<br >/g, '')
      .replace(/%/g, '');

  /**
   * 操作弹窗
   * params参数：
   *  title： 标题
   *  options：操作按钮名称，数组
   *  floorNum：取消按钮的位置
   *  tintColor：颜色
   *  disabledButtonIndices
   * */
  static actionSheetWeb = (params: {[key: string]: unknown}): Promise<any> =>
    new Promise((resolve, reject) => {
      (window as any).api.actionSheet(params, (ret: any, err: any) => {
        if (ret !== null) {
          resolve(ret);
        } else {
          reject(err);
        }
      });
    });

  /**
   * 是否绑定手机号
   */
  static isBindPhoneWeb = (): Promise<any> =>
    new Promise((resolve, reject) => {
      (window as any).api.isBindPhone((ret: any, err: any) => {
        if (ret !== null) {
          resolve(ret);
        } else {
          reject(err);
        }
      });
    });

  /**
   * 【重要】登陆路由
   * 本方法不支持afterLoginAction,需要自行配合mmbViewDidFocus处理
   * @param params
   * @returns {Promise<void>}
   */
  static routerAction = (params: {[key: string]: any}): void => {
    if ((MainUtils.isAppVer('3.9.50') || MainUtils.isAppVer('3.9.51')) && !MainUtils.isLogin()) {
      // 存在极光登录导致mmbViewDidFocus无法触发的问题
      (window as any).MMBJsBridge.commonAction(
        'func',
        `MainUtils.openWin({name: 'LoginScene', navi: navigation, pageParam: ${JSON.stringify(
          params,
        )}, key: 'LoginScene'})`,
      );
    } else {
      (window as any).MMBJsBridge.commonAction(
        'func',
        `MainUtils.routerAction(navigation,${JSON.stringify(params)})`,
      );
    }
  };

  /**
   * 窗体滚动事件
   * @param func
   */
  static onscroll = (func: unknown): void => {
    const Window = window as any;
    if (Window.onscroll) {
      Window.onscroll = HelpUtils.mergeFunction(Window.onscroll, func);
    } else {
      Window.onscroll = func;
    }
  };

  /**
   * 判断是否是安装app，只能在app内调用
   * 3.9.91 加入
   * @param linkArr
   */
  static isInstallApp = (linkArr: Array<string>): Promise<any> => {
    return new Promise(resolve => {
      const appInfo: AppInfoTypes = MainUtils.appInfo();
      if (MainUtils.isInApp() && (appInfo?.c_appver ?? '') !== '') {
        if (
          ((appInfo?.c_app ?? '') === 'ddd' &&
            Number((appInfo?.c_appver ?? '').replace(/\./g, '')) > 159) ||
          (appInfo?.c_app ?? '') === 'lsjgcx'
        ) {
          (window as any).api.isInstallApp(
            {
              urls: linkArr,
            },
            (ret: any) => {
              resolve(ret?.isInstall ?? false);
            },
          );
        } else if (Number((appInfo?.c_appver ?? '').replace(/\./g, '')) > 3990) {
          (window as any).api.isInstallApp(
            {
              urls: linkArr,
            },
            (ret: any) => {
              resolve(ret?.isInstall ?? false);
            },
          );
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  };

  /**
   * 处理时间显示(精选折扣以及网友推荐用到)。当天的显示小时：分，当年的显示月：日，不是当年显示年月日
   * @param strTime 传入的日期格式必须是（年月日 时分秒）
   * @param type type不传走默认，传1
   * @returns {string}
   */
  static funcTimeShow = (strTime: string, type: number): string => {
    if (strTime === null || strTime === '' || strTime === undefined) {
      return '';
    }

    function p(s: string | number) {
      // 创建补0函数
      return s < 10 ? `0${s}` : s;
    }
    let returnStr = '';
    let strTimeNew = strTime;
    try {
      if (strTimeNew.indexOf('-') > 0) {
        strTimeNew = strTimeNew.replace(/-/g, '/');
      }

      if (strTimeNew.split(' ')[0].split('/').length < 3) {
        strTimeNew = `${new Date().getFullYear()}/${strTimeNew}`;
      }

      // 先格式化成标准的yyyy/m/d h:m:s
      let monthStr = strTimeNew.split(' ')[0].split('/')[1];
      let dateStr = strTimeNew.split(' ')[0].split('/')[2];
      let hourStr = strTimeNew.split(' ')[1].split(':')[0];
      let minuteStr = strTimeNew.split(' ')[1].split(':')[1];
      let secondStr = strTimeNew.split(' ')[1].split(':')[2];
      if (monthStr.length > 1 && Number(monthStr) < 10) {
        monthStr = monthStr.substring(1, 2);
      }
      if (dateStr.length > 1 && Number(dateStr) < 10) {
        dateStr = dateStr.substring(1, 2);
      }
      if (hourStr.length > 1 && Number(hourStr) < 10) {
        hourStr = hourStr.substring(1, 2);
      }
      if (minuteStr.length > 1 && Number(minuteStr) < 10) {
        minuteStr = minuteStr.substring(1, 2);
      }
      if (secondStr) {
        if (secondStr.length > 1 && Number(secondStr) < 10) {
          secondStr = secondStr.substring(1, 2);
        }
      } else {
        secondStr = '0';
      }
      strTimeNew = `${
        strTimeNew.split('/')[0]
      }/${monthStr}/${dateStr} ${hourStr}:${minuteStr}:${secondStr}`;

      // 时间格式化
      const returnYear = strTimeNew.split(' ')[0].split('/')[0];
      const returnMouth = p(strTimeNew.split(' ')[0].split('/')[1]);
      const returnDay = p(strTimeNew.split(' ')[0].split('/')[2]);
      const returnHour = p(strTimeNew.split(' ')[1].split(':')[0]);
      const returnMinute = p(strTimeNew.split(' ')[1].split(':')[1]);
      let trueTime = 0;
      if (
        `${new Date().getFullYear()}/${
          new Date().getMonth() + 1
        }/${new Date().getDate()}`.toLocaleString() === strTimeNew.split(' ')[0]
      ) {
        trueTime = 0; // 当天的
      } else if (parseInt(strTimeNew.split(' ')[0].substr(0, 4), 10) === new Date().getFullYear()) {
        trueTime = 1; // 当年的
      } else {
        trueTime = 2; // 不是当年的
      }

      if (type) {
        if (type === 1) {
          // 当年的显示 月日秒，不是当年的显示年月日
          if (trueTime !== 2) {
            returnStr = `${returnMouth}-${returnDay} ${returnHour}:${returnMinute}`;
          } else {
            returnStr = `${returnYear}-${returnMouth}-${returnDay}`;
          }
        }
      } else if (trueTime === 0) {
        // 当天的
        returnStr = `${returnHour}:${returnMinute}`;
      } else if (trueTime === 1) {
        // 当年的
        returnStr = `${returnMouth}-${returnDay}`;
      } else {
        // 不是当年的
        returnStr = `${returnYear}-${returnMouth}-${returnDay}`;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
    return returnStr;
  };
}

export default MainUtils;
